import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { Dropdown, DropdownItem, DropdownMenu } from 'components/Dropdown2';
import { PFE_ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import './ActionsDropdown.scss';

const { block, element } = bem('schedule-detail-v2-actions-dropdown');

const ActionsDropdown = ({ dataCypress, frosted = false, icon, items, label }) => (
  <Dropdown className={block()} attachment="right" dataCypress={dataCypress} disabled={frosted}>
    {({ toggleMenu }) => (
      <>
        <button
          type="button"
          aria-label={label}
          className={element('toggle', { frosted })}
          disabled={frosted}
          onClick={toggleMenu}>
          <Isvg className={element('icon')} src={icon} />
          <Isvg className={element('chevron')} src={PFE_ICONS.chevronDownSmall} />
        </button>
        <DropdownMenu>
          {items.map(({ danger, key, label: itemLabel, onSelect }) => (
            <DropdownItem key={key} className={element('item', { danger })} onClick={onSelect}>
              {itemLabel}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </>
    )}
  </Dropdown>
);

ActionsDropdown.propTypes = {
  dataCypress: PropTypes.string,
  frosted: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      danger: PropTypes.bool,
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      onSelect: PropTypes.func.isRequired,
    })
  ).isRequired,
  label: PropTypes.string,
};

export default ActionsDropdown;
